import { FadeUp } from "@/components/Reveal";

const AVAIL_STYLE = {
  "In stock": "bg-sage text-cream",
  "Low stock": "bg-gold text-espresso",
  "Made to order": "bg-chocolate text-cream",
};

export default function ProductCard({ product, onEnquire, index = 0 }) {
  return (
    <FadeUp delay={Math.min(index * 0.07, 0.4)} className="h-full">
      <article
        data-testid={`product-card-${product.id}`}
        className="group h-full flex flex-col bg-ivory border border-chocolate/10 hover:border-gold/70 hover:shadow-[0_24px_50px_-28px_rgba(26,15,10,0.35)] transition-all duration-500"
      >
        <button
          onClick={() => onEnquire(product)}
          data-testid={`product-image-${product.id}`}
          className="relative overflow-hidden aspect-[4/5] w-full text-left cursor-pointer"
          aria-label={`View ${product.name}`}
        >
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="img-warm absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.06]"
          />
          <span
            className={`absolute top-4 left-4 font-mono text-[9px] uppercase tracking-[0.2em] px-3 py-1.5 ${AVAIL_STYLE[product.availability] || "bg-chocolate text-cream"}`}
          >
            {product.availability}
          </span>
          <span className="absolute inset-0 bg-espresso/0 group-hover:bg-espresso/10 transition-colors duration-500" />
        </button>
        <div className="p-6 flex flex-col flex-1">
          <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-golddark mb-2">{product.category}</p>
          <h3 className="font-serif text-2xl font-medium text-chocolate">{product.name}</h3>
          <p className="text-sm text-chocolate/60 mt-1.5 leading-relaxed">{product.tagline}</p>
          <div className="mt-auto pt-5 flex items-center justify-between">
            <span className="font-serif text-xl text-chocolate">{product.price}</span>
            <button
              onClick={() => onEnquire(product)}
              data-testid={`product-card-enquire-button-${product.id}`}
              className="font-mono text-[10px] uppercase tracking-[0.2em] text-golddark border-b border-gold/50 pb-0.5 hover:text-chocolate hover:border-chocolate transition-colors"
            >
              View &amp; Enquire
            </button>
          </div>
        </div>
      </article>
    </FadeUp>
  );
}
